import { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import { useGetRepaymentSchedule } from '@/query/queries/loan/useGetRepaymentSchedule';
import { Checkbox } from '@/webkit/form/Checkbox';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useGetMe } from '@/hooks/useGetMe';
import { USER_STATUSES } from '@/helpers/constants';
import { RepScheduleTable } from './table';
import { RepScheduleList } from './list';
import s from './index.module.scss';

export const REPAYMENT_STATUSES = t => ({
  scheduled: { label: t('scheduled') },
  paid: { label: t('paid') },
  paid_overdue: { label: t('paid_after_due_date') },
  paid_partially: { label: t('partially_paid') },
  paid_partially_late: { label: t('late_partially_paid') },
  late: { label: t('late') }
});

const RepaymentScheduleModule = () => {
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
    exclude_paid: 1,
  });

  const { innerWidth } = useWindowSize();
  const { profile } = useGetMe();
  const { t } = useTranslation('repayment_schedule');
  const { data: repaymentSchedule, isLoading } =
    useGetRepaymentSchedule(params);

  const excludePaid = params.exclude_paid === 1;
  const isEmpty = !repaymentSchedule?.list.length;

  if (profile?.status === USER_STATUSES.suspended && isEmpty) {
    return (
      <div className={s.wrapper}>
        <SuspendResidenceWarning />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      {profile?.status === USER_STATUSES.suspended && (
        <SuspendResidenceWarning className={s.warning} />
      )}

      {!isEmpty && repaymentSchedule?.show_extend_disclaimer && (
        <div className={classnames(s.disclaimer, 'f-small-regular')}>
          {t('repayment_schedule_disclaimer')}{' '}
          <MyLink href={APP_LINKS.helpLoanTerms()} underline>
            {t('loan_terms')}
          </MyLink>
          .
        </div>
      )}

      <div className={s.controls}>
        <div className="f-small-regular">{t('repayments_from_claims')}</div>
        <Checkbox
          name="excludePaid"
          checked={excludePaid}
          onChange={() =>
            setParams(prev => ({ ...prev, exclude_paid: excludePaid ? 0 : 1 }))
          }
        >
          <span className={classnames('f-small-regular')}>
            {t('hide_paid_payments')}
          </span>
        </Checkbox>
      </div>

      {innerWidth < 992 ? (
        <RepScheduleList data={repaymentSchedule?.list} isLoading={isLoading} />
      ) : (
        <RepScheduleTable
          data={repaymentSchedule?.list}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default RepaymentScheduleModule;
